import React, { useState, useEffect, useCallback } from 'react';

import {
  CompanySelectModel,
  CustomerCompaniesFilterEnum,
} from 'api/adminApiClient';
import CompanyFilter from 'components/filters/CompanyFilter';
import { getApprovedClientsCompanies } from 'redux/reducers/clientSlice';
import { useAppDispatch } from 'hooks/useAppDispatch';

type Props<T> = {
  filters: T;
  onChange: (data: T) => void;
  value?: string[];
  customerCompaniesFilter: CustomerCompaniesFilterEnum;
};

export default function ClientsFilter<T>(props: Props<T>) {
  const { filters, onChange, value, customerCompaniesFilter } = props;
  const [companies, setCompanies] = useState<CompanySelectModel[]>([]);
  const [isCompaniesLoaded, setIsCompaniesLoaded] = useState(false);

  const dispatch = useAppDispatch();

  const loadCompanies = useCallback(async () => {
    const result = await dispatch(
      getApprovedClientsCompanies({ customerCompaniesFilter }),
    );

    if (getApprovedClientsCompanies.fulfilled.match(result)) {
      setCompanies(result.payload);
    }
    setIsCompaniesLoaded(true);
  }, [dispatch, customerCompaniesFilter]);

  useEffect(() => {
    loadCompanies();
  }, [loadCompanies]);

  return (
    <CompanyFilter
      filters={filters}
      onChange={onChange}
      companies={companies}
      isCompaniesLoaded={isCompaniesLoaded}
      value={value}
    />
  );
}
